"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToArrowKey = void 0;
var tslib_1 = require("tslib");
var operators_1 = require("rxjs/operators");
var filter_keys_in_list_1 = require("../filter-keys-in-list");
var map_to_key_1 = require("../map-to-key");
var mapToArrowKey = function () { return function (keyEvents$) {
    return keyEvents$.pipe((0, filter_keys_in_list_1.filterKeyInList)(['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']), (0, operators_1.filter)(function (_a) {
        var _b = tslib_1.__read(_a, 1), du = _b[0];
        return du === 'down';
    }), (0, map_to_key_1.mapToKey)());
}; };
exports.mapToArrowKey = mapToArrowKey;
